import { ConsultationContact } from '../types/consultation';
import { addToRecent, loadRecentContacts, saveRecentContacts } from '../../../common/recent/storage';
import { isEmpty } from 'lodash';

const STORAGE_KEYS = {
  CONTACTS: 'consult_contacts',
  LAST_SYNC: 'consult_last_sync'
};

/**
 * Save contacts to localStorage
 */
export function saveContactsToStorage(contacts: ConsultationContact[]): void {
  try {
    const existingContacts = JSON.parse(localStorage.getItem(STORAGE_KEYS.CONTACTS) || '[]') as ConsultationContact[];
    
    // Deduplicate by targetId
    const contactMap = new Map();
    [...existingContacts, ...contacts].forEach(c => {
      if (c && c.targetId) {
        contactMap.set(c.targetId, c);
      }
    });
    
    const merged = Array.from(contactMap.values());
    localStorage.setItem(STORAGE_KEYS.CONTACTS, JSON.stringify(merged));
    localStorage.setItem(STORAGE_KEYS.LAST_SYNC, new Date().toISOString());
  } catch (error) {
    console.error('Error saving contacts to localStorage:', error);
  }
}

/**
 * Load contacts from localStorage
 */
export function loadContactsFromStorage(): ConsultationContact[] {
  try {
    const data = localStorage.getItem(STORAGE_KEYS.CONTACTS);
    if (data) {
      return JSON.parse(data) as ConsultationContact[];
    }
  } catch (error) {
    console.error('Error loading contacts from localStorage:', error);
  }
  return [];
}

export { addToRecent, loadRecentContacts, saveRecentContacts };

/**
 * Get last sync timestamp
 */
export function getLastSyncTimestamp(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEYS.LAST_SYNC);
  } catch (error) {
    return null;
  }
}

/**
 * Check if contacts need refresh (older than 1 hour)
 */
export function shouldRefreshContacts(): boolean {
  const lastSync = getLastSyncTimestamp();
  if (!lastSync) return true;
  
  const lastSyncTime = new Date(lastSync).getTime();
  const oneHourAgo = Date.now() - (60 * 60 * 1000);
  
  return lastSyncTime < oneHourAgo;
}

